import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0 16px 40px;
    }

    .name-title {
      margin: 0 0 16px;
      font-family: Poppins;
      font-weight: 600;
      font-style: italic;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
    }

    .name-input-container {
      max-width: 372px;
      width: 100%;
      margin: 0 auto;
    }
  }
`;
